// Stub tabs for the webclient rail. Calls/Voicemail land in W3 (#389),
// Contacts/Settings in W4 (#390), Meet later. Kept minimal so the shell + Chat
// ship now without dead links.

export default function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <div className="h-full flex items-center justify-center p-8 text-center">
      <div className="max-w-md">
        <div className="text-lg font-semibold mb-2">{title}</div>
        <div className="text-textSecondary text-sm">{note}</div>
      </div>
    </div>
  );
}
